<script lang="ts" setup>
import { useTemplateRef, watch } from 'vue';

defineProps<{ date: Date; content: string; value: string }>();
const isSelectedModel = defineModel<boolean>();
defineEmits<{ selected: []; }>();
const inputRef = useTemplateRef<HTMLInputElement>('inputRef');

watch(isSelectedModel, (isSelected) => {
  const input = inputRef.value;

  if (!input) {
    return;
  }

  input.checked = !!isSelected;
});
</script>

<template>
  <div :data-value="modelValue">
    <input :id="`date-${value}`" ref="inputRef" type="radio" @change="$emit('selected')" />

    <!-- biome-ignore lint/a11y/noLabelWithoutControl: Aria Label provided using binding -->
    <label :for="`date-${value}`" :aria-label="value" v-html="content"></label>
  </div>
</template>
